import { FDBodyText } from '@facet-wealth/design';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import fr from 'facet-rest';

export const GoalDetailOverride = fr.metaOverride({ base: BaseOverride })
  .nameOverride('title', {
    hidden: false, // This is here because BaseOverride sets it to hidden: true for title
    _component: () => Text,
    _customProps: {
      variant: 'h1',
      weight: 'medium',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDBodyText,
    _customProps: {
      color: 'textDisabled',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('goalNumber', {
    hidden: true,
  }, overrideReadOnly)
  .typeOverride('date',
    {
      _customProps: {
        format: 'MM/YYYY',
        views: ['year', 'month'],
      },
    }, overrideReadOnly);
